import { Box, Flex, Text, TextProps } from '@everlywell/ui-kit';
import React from 'react';

import ReviewsBackground from './assets/ReviewsBackground.png';
import ReviewsBackgroundMobile from './assets/ReviewsBackgroundMobile.png';

export type StatCardProps = TextProps & {
  recommendedRatio: number;
};

function StatCard(props: StatCardProps): JSX.Element {
  const recommendedPercentage = Math.round(props.recommendedRatio * 100);

  return (
    <Box
      position={'relative'}
      backgroundColor={'eggplant.base'}
      // use 102% to have the background image cover the whole box
      background={[
        `url(${ReviewsBackgroundMobile}) center center / cover no-repeat`,
        `url(${ReviewsBackground}) center 33% / 102% no-repeat`,
      ]}
      borderRadius={'12px'}
      // desktop width from the design
      width={['100%', '551px']}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      paddingY={[5, 0]}
      paddingX={[6, 0]}
    >
      <Flex
        flexDirection={['row', 'column']}
        gap={[4, 0]}
        alignItems={'center'}
      >
        <Text
          fontSize={['7xl', '86px']}
          color={'eggplant.wash'}
          fontWeight={'normal'}
        >
          {recommendedPercentage}%
        </Text>

        <Flex
          position={['static', 'absolute']}
          alignItems={'center'}
          justifyContent={'center'}
          bottom={[0, 8]}
        >
          <Text
            size={'lg'}
            color={'tints.white'}
            textAlign={['left', 'center']}
          >
            Would recommend this test to a friend
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
}

export default StatCard;
